import CustomZObject from './CustomZObject.js';
import {TIDALS} from 'messaging/message-types.js';

export default class JRepl extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet(TIDALS, (x) => this.tidals = x[0]);
        this.newInlet("toggle lock", (x) => this.lock(x[0]));
    }

    lock(number) {
        if (this.tidals[number]) {
            this.tidals[number].lockGroove(!this.tidals[number].cycleParameter.immutable);
        }
    }
    
}
